import React, { useState, useEffect } from 'react';
import {
    PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import api from "../../../services/api.js";
import { useAppContext } from '../../../context/AppContext.js';
import './style.css';
import confetti from 'canvas-confetti';
import PopUp from "../../../componente/popup/index.jsx";

const PainelCheckList = ({ dt1, dt2, busca, codsetor, codfuncao, codequipe }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [aTipo, setaTipo] = useState('');

    const [dadosConcluido, setDadosConcluido] = useState([]);
    const [dadosConforme, setDadosConforme] = useState([]);
    const [dadosPrazo, setDadosPrazo] = useState([]);
    const [dadosAvaliacao, setDadosAvaliacao] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState(null);

    const [rankingConcluido, setRankingConcluido] = useState([]);
    const [rankingConforme, setRankingConforme] = useState([]);
    const [rankingPrazo, setRankingPrazo] = useState([]);
    const [rankingAvaliacao, setRankingAvaliacao] = useState([]);

    const { codassinante, selectedCompany, accessKey } = useAppContext();

    const COLORS = ['#00836bff', '#fcb41aff', '#ff0800ff', '#8884d8', '#82ca9d', '#0088FE'];

    useEffect(() => {
        const fetchDataTamanho = async () => {
            try {
                setCarregando(true);
                setErro(null);
                const response = await api.get("/v1/grafico/checklist", {
                    params: {
                        codempresa: selectedCompany,
                        codassinante,
                        dt1,
                        dt2,
                        busca,
                        codsetor,
                        codfuncao,
                        codequipe
                    },
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                });

                setDadosConcluido(response.data.concluido);
                setDadosConforme(response.data.conforme);
                setDadosPrazo(response.data.prazo);
                setDadosAvaliacao(response.data.avaliacao);

                setRankingConcluido(response.data.rankingconcluido);
                setRankingConforme(response.data.rankingconforme);
                setRankingPrazo(response.data.rankingprazo);
                setRankingAvaliacao(response.data.rankingavaliacao);

            } catch (error) {
                console.error('Erro ao buscar dados:', error);
                setErro('Erro ao carregar os dados. Tente novamente.');
            } finally {
                setCarregando(false);
            }
        };

        fetchDataTamanho();
    }, [selectedCompany, dt1, dt2, busca, codsetor, codfuncao, codequipe]);

    const RADIAN = Math.PI / 180;

    const wrapText = (text, maxLineLength = 15) => {
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";

        words.forEach((word) => {
            if ((currentLine + " " + word).trim().length <= maxLineLength) {
                currentLine += (currentLine ? " " : "") + word;
            } else {
                lines.push(currentLine);
                currentLine = word;
            }
        });

        if (currentLine) lines.push(currentLine);
        return lines;
    };

    const handleOpen = (tipo) => {
        setaTipo(tipo);
        setIsOpen(true);
    };

    const handleConfirma = async () => {
        setIsOpen(false);
        await handleTrophyClick(aTipo);
    };

    const handleClose = () => {        
        setIsOpen(false);
    };

    async function handleTrophyClick(tipo) {
        try {
            let endpoint = "";
            if (tipo === 'Concluído') endpoint = "/v1/premioconcluido";
            if (tipo === 'Conforme') endpoint = "/v1/premioconforme";
            if (tipo === 'Prazos') endpoint = "/v1/premioprazo";
            if (tipo === 'Avaliação') endpoint = "/v1/premioavaliacao";

            if (endpoint) {
                await api.post(endpoint, {
                    codempresa: selectedCompany,
                    codassinante,
                    tipo,
                    busca,
                    dt1,
                    dt2,
                    codsetor,
                    codfuncao,
                    codequipe
                }, {
                    headers: { Authorization: `Bearer ${accessKey}` },
                });
            }

        } catch (error) {
            console.error('Erro ao premiar:', error);
        } finally {
            confetti({
                particleCount: 100,
                spread: 70,
                origin: { y: 0.6 }
            });
        }
    }

    // ✅ Agora sem useState, só props
    const renderRankingList = (dados, title, onOpen) => {
        const colorMap = {
            0: COLORS[0],
            1: COLORS[1],
            2: COLORS[2],
            3: COLORS[3],
            4: COLORS[4],
            5: COLORS[5]
        };

        return (
            <div className="mw-1 mt-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="flex-grow-1 text-center m-0">Ranking {title}</h5>
                    <button
                        type="button"
                        className="btn btn-warning ms-3"
                        title="Ver ranking por equipe"
                        onClick={() => onOpen(title)}
                    >
                        <i className="fa-solid fa-trophy"></i>
                    </button>
                </div>

                <ul className="list-group">
                    {dados.map((item, index) => (
                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                            <div>
                                <span
                                    className="badge me-2"
                                    style={{
                                        backgroundColor: colorMap[item.tipo] || "#6c757d",
                                        color: "white",
                                        minWidth: 10,
                                        display: "inline-block",
                                        textAlign: "center"
                                    }}
                                />
                                {item.nomecolaborador}
                            </div>
                            <span className="badge bg-primary rounded-pill">
                                {item.qtde}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    const renderCustomizedLabel = ({ cx, cy, midAngle, outerRadius, percent, index, name, qtde }) => {
        const radius = outerRadius * 1.3;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        const lines = wrapText(`${name}: ${qtde} (${(percent * 100).toFixed(1)}%)`);

        return (
            <text
                x={x}
                y={y}
                textAnchor={x > cx ? "start" : "end"}
                dominantBaseline="central"
                fontSize={12}
                fontFamily="inherit"
                fontWeight="bold"
                fill={COLORS[index % COLORS.length]}
            >
                {lines.map((line, i) => (
                    <tspan key={i} x={x} dy={i === 0 ? 0 : 14}>
                        {line}
                    </tspan>
                ))}
            </text>
        );
    };

    const renderDonutChart = (data, title, descricao) => {
        const total = data.reduce((acc, item) => acc + item.qtde, 0);
        const media = data.length > 0 ? total / data.length : 0;

        return (
            <div className="grafico-container">
                <h4 className='text-center'>{title}</h4>
                <h6 className='text-center'>{descricao}</h6>
                <div className='text-center mb-2'>
                    <strong>Total:</strong> {total} | <strong>Média:</strong> {media.toFixed(1)}
                </div>
                <ResponsiveContainer width='100%' height={250}>
                    <PieChart>
                        <Pie
                            data={data}
                            dataKey="qtde"
                            nameKey="label"
                            cx="50%"
                            cy="50%"
                            innerRadius={35}
                            outerRadius={55}
                            paddingAngle={2}
                            label={renderCustomizedLabel}
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip formatter={(value) => `${value}`} />
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        );
    };

    if (carregando) return <div>Carregando dados...</div>;
    if (erro) return <div>{erro}</div>;

    return (
        <div className="painel">
            {/* PopUp único, controlado pelo pai */}
            <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja premiar o ranking {aTipo}?</p>
                <div className="row">
                    <div className="col-12 mt-3 d-flex justify-content-end">
                        <button className="btn btn-primary me-2" onClick={handleConfirma}>Sim</button>
                        <button className="btn btn-danger" onClick={handleClose}>Não</button>
                    </div>
                </div>
            </PopUp>

            <div className='row'>
                <div className='col-xl-3 col-lg-4 col-md-6 col-sm-12'>
                    {renderDonutChart(dadosConcluido, "Concluido", "Índice de Realização")}
                    {renderRankingList(rankingConcluido, "Concluído", handleOpen)}
                </div>
                <div className='col-xl-3 col-lg-4 col-md-6 col-sm-12'>
                    {renderDonutChart(dadosConforme, "Conforme", "Índice de Qualidade")}
                    {renderRankingList(rankingConforme, "Conforme", handleOpen)}
                </div>
                <div className='col-xl-3 col-lg-4 col-md-6 col-sm-12'>
                    {renderDonutChart(dadosPrazo, "Prazo", "Índice de Eficiência")}
                    {renderRankingList(rankingPrazo, "Prazos", handleOpen)}
                </div>
                <div className='col-xl-3 col-lg-4 col-md-6 col-sm-12'>
                    {renderDonutChart(dadosAvaliacao, "Avaliação", "Índice de Excelência")}
                    {renderRankingList(rankingAvaliacao, "Avaliação", handleOpen)}
                </div>
            </div>
        </div>
    );
};

export default PainelCheckList;
